import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Logo } from "../components/brand/Logo";

// Mode maintenance (B23) : lit /api/site-settings (cache module-level) et expose
// l'état aux layouts publics/client. L'admin (/admin) n'est JAMAIS bloqué.
let cache = null;

export function useMaintenanceMode() {
  const [on, setOn] = useState(cache === true);
  useEffect(() => {
    api.get("/site-settings").then((r) => {
      cache = Boolean(r.data?.maintenance_mode);
      setOn(cache);
    }).catch(() => {});
  }, []);
  return on;
}

export function MaintenancePage() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-cream px-6 py-20 text-center" data-testid="maintenance-page">
      <Logo className="h-14 w-auto" />
      <p className="overline-ae mt-10">Maintenance</p>
      <h1 className="mt-4 font-heading text-3xl text-deepgreen sm:text-4xl">Site en maintenance</h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-muted-foreground">
        Nous apportons quelques améliorations au site. Art Event revient très vite —
        pour toute urgence : <a href="mailto:contact@art-events.fr" className="font-semibold text-deepgreen underline">contact@art-events.fr</a> ou 06 88 60 83 53.
      </p>
      <p className="mt-8 text-xs text-muted-foreground/70">L'équipe d'administration conserve un accès complet au back-office.</p>
    </div>
  );
}
